import { getOrderTicketQuantityForRedemptionCard, getOrderTicketQuantityForVoucher, getOrderTicketRedemptionCardById, getOrderTicketRedemptionCardRedemptionDetails, getOrderVoucherById, getOrderVoucherRedemptionDetails } from '@vista/omnichannel-components-domain';
import { getTicketRedemptionCodeTypeForCard } from '../../../../utils/ticket-redemption-code-type-utils';
export function getTicketRedemptionDetails(displayText, ticket, i18n) {
    const { voucherId, ticketRedemptionCardId } = ticket;
    if (!!voucherId)
        return getVoucherRedemptionDetails(displayText, voucherId, i18n);
    if (!!ticketRedemptionCardId) {
        return getTicketRedemptionCardRedemptionDetails(displayText, ticketRedemptionCardId, i18n);
    }
    return undefined;
}
const getVoucherRedemptionDetails = (displayText, voucherId, i18n) => {
    const { maskedBarcode } = getOrderVoucherById(voucherId);
    const { availableRedemptions } = getOrderVoucherRedemptionDetails(voucherId);
    const formattedCodeDetails = getFormattedRedemptionCodeDetails(displayText, maskedBarcode, i18n);
    if (availableRedemptions === 1) {
        return i18n.template(displayText.ticketSingleUseRedemptionDetailsFormat, {
            formattedCodeDetails
        });
    }
    const selectedQuantity = getOrderTicketQuantityForVoucher(voucherId);
    return i18n.template(displayText.ticketMultiUseRedemptionDetailsFormat, {
        formattedCodeDetails,
        remainingRedemptions: availableRedemptions - selectedQuantity,
        maximumRedemptions: availableRedemptions
    });
};
const getTicketRedemptionCardRedemptionDetails = (displayText, ticketRedemptionCardId, i18n) => {
    const { maskedCardNumber, memberName } = getOrderTicketRedemptionCardById(ticketRedemptionCardId);
    const { redemptionLimit } = getOrderTicketRedemptionCardRedemptionDetails(ticketRedemptionCardId);
    const formattedCodeDetails = getFormattedRedemptionCodeDetails(displayText, maskedCardNumber, i18n, memberName);
    if (redemptionLimit.isUnlimited) {
        return i18n.template(displayText.ticketUnlimitedUseRedemptionDetailsFormat, {
            formattedCodeDetails
        });
    }
    if (redemptionLimit.maximum === 1) {
        return i18n.template(displayText.ticketSingleUseRedemptionDetailsFormat, {
            formattedCodeDetails
        });
    }
    const selectedQuantity = getOrderTicketQuantityForRedemptionCard(ticketRedemptionCardId);
    return i18n.template(displayText.ticketMultiUseRedemptionDetailsFormat, {
        formattedCodeDetails,
        remainingRedemptions: redemptionLimit.maximum - selectedQuantity,
        maximumRedemptions: redemptionLimit.maximum
    });
};
const getFormattedRedemptionCodeDetails = (displayText, maskedCode, i18n, memberName) => {
    const { ticketRedemptionCodeDetailsFormat, ticketRedemptionCodeDetailsNamedFormat } = displayText;
    if (!memberName)
        return i18n.template(ticketRedemptionCodeDetailsFormat, { maskedCode });
    return i18n.template(ticketRedemptionCodeDetailsNamedFormat, {
        maskedCode,
        formattedMemberName: i18n.personName(memberName)
    });
};
export const getIconForOrderTicket = (ticket) => {
    var _a;
    const { ticketRedemptionCardId } = ticket;
    if (!ticketRedemptionCardId)
        return undefined;
    const card = getOrderTicketRedemptionCardById(ticketRedemptionCardId);
    return (_a = getTicketRedemptionCodeTypeForCard(card)) === null || _a === void 0 ? void 0 : _a.iconName;
};
